import { useState, useEffect } from 'react'
import { getSpaceDetails } from '../../../../api-utils'

/**
 * Hook to load space details from the backend
 * @param spaceId - The ID of the space to load
 * @returns Object with space data, loading state, and error message
 */
export function useSpaceLoader(spaceId: string | null) {
  const [space, setSpace] = useState<any>()
  const [hasLoaded, setHasLoaded] = useState<boolean>(false)
  const [error, setError] = useState<string>()

  useEffect(() => {
    if (spaceId && !space && !hasLoaded) {
      setHasLoaded(false)
      getSpaceDetails(spaceId)
        .then((response: any) => {
          if (response.success) {
            setSpace(response.space)
            setError(undefined)
          } else {
            throw new Error(response.error || 'Failed to load space')
          }
        })
        .catch((err: any) => {
          console.error("Error getting space", err)
          setError(`Failed to load space information: ${err.message || 'Unknown error'}`)
        })
        .finally(() => setHasLoaded(true))
    }
  }, [spaceId, space, hasLoaded])

  return { space, hasLoaded, error }
}
